/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LEARN MORE
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
const fade = {
	// background: 'linear-gradient(180deg, rgba(153,218,255,0) 0%, rgba(255,255,255,1) 100%)',
	background: replacePXinStringWithEM(`linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 62%, rgba(255,255,255,1) 100%)`),
	content: '" "',
	display: 'block',
	width: '100%',
	left: '0',
	position: 'absolute',
	height: pxToEm(35),
	top: pxToEm(-35)
};
export default theme => ({
	learnmore: {
		background: theme.color.light.light.swatch,
		position: 'absolute',
		bottom: '0',
		left: '0',
		width: '100%',
		height: '34%',
		// overflow: 'hidden',
		transition: 'height .2s ease-in-out 0s',
		'&.active': {
			height: replacePXinStringWithEM('calc(100% - 65px)'),
			'& .inner .message': {
				overflow: 'auto' // so that if message is too long we can see all of it
			}
		},
		'& .inner': {
			height: '100%',
			padding: replacePXinStringWithEM('0px 40px'),
			position: 'relative',
			'& .message': {
				overflow: 'hidden', // will make this auto when we're active
				height: '100%',
				color: theme.color.dark.dark.swatch,
				extend: theme.typography.size.small,
				textAlign: 'left',
				// fade effect
				'&:before': {
					extend: fade,
					height: pxToEm(40),
					top: pxToEm(-40)
				},
				// buffer for bottom cta so all text is visible
				'&:after': {
					content: '" "',
					display: 'block',
					width: '100%',
					height: pxToEm(70)
				}
			},
			'& .cta': {
				background: theme.color.light.light.swatch,
				cursor: 'pointer',
				// paddingBottom: pxToEm(5),
				position: 'absolute',
				bottom: '0',
				left: '0',
				width: '100%',
				display: 'flex',
				justifyContent: 'center',
				'&:before': {
					extend: fade
				},
				'& .button': {
					background: theme.color.primary.light.swatch,
					borderRadius: pxToEm(15),
					height: pxToEm(35),
					width: pxToEm(126),
					color: theme.color.primary.medium.swatch,
					padding: replacePXinStringWithEM(`0px 5px`),
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					position: 'relative',
					bottom: pxToEm(16),
					'& .text': {
						extend: theme.typography.size.small,
						userSelect: 'none'
					}
				}
			}
		}
	}
});